<script setup>
import { useCookie, useNuxtApp, useRoute } from "#imports";
import LazyGridOverlay from "@voix/components/slicer/design-guide/GridOverlay.vue";
import { getCurrentUser } from "@voix/composables/queries/useQueryCurrentUser";
import { useVoixUserAuth } from "@voix/composables/useVoixUserAuth";
import { usePageStore } from "@voix/store/pageStore";
import { computed, onMounted, provide, ref } from "vue";
import VoixElementsLoop from "./VoixElementsLoop.vue";
const pageStore = usePageStore();
function kebabCase(string) {
  return string.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
const originalLayoutName = computed(() => pageStore.currentPage?.layout);
const layout = computed(() => {
  if (pageStore.currentPage)
    return kebabCase(pageStore.currentPage.layout);
  return null;
});
provide("voixLayout", layout);
const route = useRoute();
const showGrid = computed(() => route.query["show-grid"] === "true");
const topElement = computed(() => {
  return pageStore.currentPage.elements.find((element) => element.enabled === true);
});
provide("topElement", topElement.value);
const { $voix } = useNuxtApp();
const { checkUserPermissions } = useVoixUserAuth();
const canEdit = ref(false);
const accessToken = useCookie("auth-access-token");
if (accessToken.value)
  getCurrentUser();
onMounted(async () => {
  $voix.eventBus.emit("voix:page:viewed", pageStore.currentPage);
  await checkUserPermissions(["Pages.Edit"]).then((value) => {
    canEdit.value = value;
  });
});
await checkUserPermissions(["Pages.Edit"]).then((value) => {
  canEdit.value = value;
});
</script>

<template>
  <div>
    <NuxtLayout v-if="layout && pageStore.currentPage" :name="layout">
      <VoixElementsLoop
        :elements="pageStore.currentPage.elements"
      />
    </NuxtLayout>

    <ClientOnly>
      <LazyVoixEditorShortcut v-if="canEdit" />
      <LazyGridOverlay v-if="showGrid" :layout="originalLayoutName" />
    </ClientOnly>
  </div>
</template>
